<div class="loader">
    <div>
        <img src="../../../../assets/images/updated-ajax-loader.gif">
    </div>
    <div *ngIf="(dataSharingService.LoadingLabelText | async) as labelText" class="labelLoading">
        <span>{{ labelText }}</span>
    </div>
</div>